module.exports = __webpack_public_path__ + "img/content-marketing.3d2da52.png";